<div class="snackbar-container">
    <span>{{data.message}}?</span>
    <div style="display: flex; gap: 20px; align-items: center;">
        <button class="btn" (click)="undo()">Undo</button>
        <img class="close" src="assets/Channels/close.svg" (click)="close()" />
    </div>
</div>